/**
 * Trainer Image Mappings
 *
 * Maps trainer names to their sprite images.
 * This is purely cosmetic data - image paths and face positioning configs.
 *
 * Functions that need SUPPORT_CARDS data now accept it as a parameter
 * to work with the GameDataContext.
 */

// Face positioning config for support trainer icons
// Manually tuned values for proper face centering
// scale: zoom level (higher = more zoomed in on face)
// offsetY: vertical offset in % (negative = move image up to show face)
// offsetX: horizontal offset in % (negative = move left, positive = move right)
export const TRAINER_FACE_CONFIG = {
  // Default config for trainers without specific settings
  default: { scale: 1.9, offsetY: 0, offsetX: 0 },
  // Manually tuned per trainer
  'Agatha': { scale: 1.9, offsetY: -14, offsetX: -3 },
  'Allister': { scale: 1.9, offsetY: 1, offsetX: 0 },
  'Archie': { scale: 1.9, offsetY: 0, offsetX: 0 },
  'Arven': { scale: 1.9, offsetY: -8, offsetX: 1 },
  'Avery': { scale: 1.9, offsetY: 0, offsetX: 0 },
  'Bea': { scale: 1.9, offsetY: -6, offsetX: 3 },
  'Blaine': { scale: 1.9, offsetY: 4, offsetX: -5 },
  'Blue': { scale: 1.9, offsetY: -3, offsetX: 0 },
  'Brock': { scale: 1.9, offsetY: -13, offsetX: 4 },
  'Bugsy': { scale: 1.9, offsetY: -6, offsetX: 1 },
  'Carmine': { scale: 1.9, offsetY: -5, offsetX: 1 },
  'Chuck': { scale: 1.9, offsetY: -6, offsetX: 1 },
  'Cilan': { scale: 1.9, offsetY: -5, offsetX: 5 },
  'Clair': { scale: 1.9, offsetY: -6, offsetX: 1 },
  'Clemont': { scale: 1.9, offsetY: -14, offsetX: 12 },
  'Dawn': { scale: 1.9, offsetY: -13, offsetX: 0 },
  'Cress': { scale: 1.9, offsetY: -2, offsetX: -2 },
  'Cynthia': { scale: 1.9, offsetY: 1, offsetX: -5 },
  'Diantha': { scale: 1.9, offsetY: 3, offsetX: 10 },
  'Drayton': { scale: 1.9, offsetY: -4, offsetX: -2 },
  'Elesa': { scale: 1.9, offsetY: -33, offsetX: 20 },
  'Erika': { scale: 1.9, offsetY: -5, offsetX: 0 },
  'Falkner': { scale: 1.9, offsetY: -6, offsetX: 1 },
  'Flannery': { scale: 1.9, offsetY: -23, offsetX: 10 },
  'Gardenia': { scale: 1.9, offsetY: -4, offsetX: 0 },
  'Geeta': { scale: 1.9, offsetY: 2, offsetX: 2 },
  'Giovanni': { scale: 1.9, offsetY: 1, offsetX: -2 },
  'Gloria': { scale: 1.9, offsetY: -4, offsetX: 0 },
  'Gordie': { scale: 1.9, offsetY: 1, offsetX: 0 },
  'Grusha': { scale: 1.9, offsetY: -8, offsetX: 0 },
  'Hop': { scale: 1.9, offsetY: -10, offsetX: 6 },
  'Iono': { scale: 1.9, offsetY: -5, offsetX: 0 },
  'Iris': { scale: 1.9, offsetY: -22, offsetX: 1 },
  'Jasmine': { scale: 1.9, offsetY: 1, offsetX: 4 },
  'Lisia': { scale: 1.9, offsetY: -2, offsetX: 0 },
  'Kabu': { scale: 1.9, offsetY: 0, offsetX: 0 },
  'Karen': { scale: 1.9, offsetY: 1, offsetX: -1 },
  'Kieran': { scale: 1.9, offsetY: -16, offsetX: -2 },
  'Klara': { scale: 1.9, offsetY: 1, offsetX: 0 },
  'Lusamine': { scale: 1.9, offsetY: -2, offsetX: 0 },
  'Koga': { scale: 1.9, offsetY: -7, offsetX: 8 },
  'Lacey': { scale: 1.9, offsetY: -10, offsetX: 3 },
  'Lance': { scale: 1.9, offsetY: -2, offsetX: 9 },
  'Leon': { scale: 1.9, offsetY: 1, offsetX: 11 },
  'Mallow': { scale: 1.9, offsetY: -11, offsetX: 5 },
  'Malva': { scale: 1.9, offsetY: 1, offsetX: 0 },
  'Marlon': { scale: 1.9, offsetY: -10, offsetX: -4 },
  'Mars': { scale: 1.9, offsetY: 0, offsetX: -1 },
  'Marnie': { scale: 1.9, offsetY: -1, offsetX: 0 },
  'Maxie': { scale: 1.9, offsetY: -2, offsetX: 0 },
  'Mustard': { scale: 1.9, offsetY: -2, offsetX: 0 },
  'Hilda': { scale: 1.9, offsetY: -8, offsetX: 4 },
  'Melony': { scale: 1.9, offsetY: 0, offsetX: -2 },
  'Milo': { scale: 1.9, offsetY: -2, offsetX: 0 },
  'Misty': { scale: 1.9, offsetY: -4, offsetX: 5 },
  'Morty': { scale: 1.9, offsetY: 0, offsetX: 6 },
  'Giacomo': { scale: 1.9, offsetY: -2, offsetX: 0 },
  'N': { scale: 1.9, offsetY: 4, offsetX: -2 },
  'Nemona': { scale: 1.9, offsetY: -9, offsetX: -1 },
  'Nessa': { scale: 1.9, offsetY: -1, offsetX: -1 },
  'Oleana': { scale: 1.9, offsetY: 3, offsetX: 4 },
  'Opal': { scale: 1.9, offsetY: -2, offsetX: 2 },
  'Penny': { scale: 1.9, offsetY: -4, offsetX: 0 },
  'Piers': { scale: 1.9, offsetY: 2, offsetX: 0 },
  'Poppy': { scale: 1.9, offsetY: -34, offsetX: 0 },
  'Professor Oak': { scale: 1.9, offsetY: -6, offsetX: 0 },
  'Pryce': { scale: 1.9, offsetY: -3, offsetX: 4 },
  'Raihan': { scale: 1.9, offsetY: 2, offsetX: 6 },
  'Lyra': { scale: 1.9, offsetY: -9, offsetX: -1 },
  'Red': { scale: 1.9, offsetY: -7, offsetX: 1 },
  'Rika': { scale: 1.9, offsetY: -6, offsetX: 0 },
  'Sabrina': { scale: 1.9, offsetY: -2, offsetX: 0 },
  'Selene': { scale: 1.9, offsetY: -13, offsetX: 1 },
  'Shelly': { scale: 1.9, offsetY: -12, offsetX: -12 },
  'Sonia': { scale: 1.9, offsetY: 0, offsetX: 0 },
  'Steven': { scale: 1.9, offsetY: 1, offsetX: 0 },
  'Victor': { scale: 1.9, offsetY: -4, offsetX: 1 },
  'Volkner': { scale: 1.9, offsetY: 2, offsetX: 0 },
  'Wallace': { scale: 1.9, offsetY: -28, offsetX: -8 },
  'Wattson': { scale: 1.9, offsetY: -1, offsetX: -2 },
  'Whitney': { scale: 1.9, offsetY: -2, offsetX: 8 },
  'Winona': { scale: 1.9, offsetY: -1, offsetX: -3 },
  'Zinnia': { scale: 1.9, offsetY: -3, offsetX: 7 },
  // Elite 4 trainers
  'Lorelei': { scale: 1.9, offsetY: -9, offsetX: 0 },
  'Bruno': { scale: 1.9, offsetY: -20, offsetX: 0 },
  'Will': { scale: 1.9, offsetY: 0, offsetX: 0 },
  'Sidney': { scale: 1.9, offsetY: -17, offsetX: 7 },
  'Phoebe': { scale: 1.9, offsetY: -8, offsetX: 2 },
  'Glacia': { scale: 1.9, offsetY: 2, offsetX: 0 },
  'Drake': { scale: 1.9, offsetY: -2, offsetX: 0 },
  'Aaron': { scale: 1.9, offsetY: -3, offsetX: -1 },
  'Bertha': { scale: 1.9, offsetY: -17, offsetX: 0 },
  'Flint': { scale: 1.9, offsetY: -2, offsetX: -4 },
  'Lucian': { scale: 1.9, offsetY: 3, offsetX: -7 },
  'Shauntal': { scale: 1.9, offsetY: -25, offsetX: 3 },
  'Grimsley': { scale: 1.9, offsetY: 1, offsetX: 4 },
  'Caitlin': { scale: 1.9, offsetY: -6, offsetX: -5 },
  'Marshal': { scale: 1.9, offsetY: -9, offsetX: -2 },
};

// Gym Leader Images
export const GYM_LEADER_IMAGES = {
  // Kanto Gym Leaders
  'Brock': '/images/trainers/supports/brock.png',
  'Misty': '/images/trainers/gym-leaders/misty.png',
  'Lt. Surge': '/images/trainers/gym-leaders/ltsurge.png',
  'Erika': '/images/trainers/gym-leaders/erika.png',
  'Koga': '/images/trainers/supports/koga.png',
  'Sabrina': '/images/trainers/gym-leaders/sabrina.png',
  'Blaine': '/images/trainers/gym-leaders/blaine.png',
  'Giovanni': '/images/trainers/gym-leaders/giovanni.png',
  // Johto Gym Leaders
  'Falkner': '/images/trainers/supports/falkner.png',
  'Bugsy': '/images/trainers/supports/bugsy.png',
  'Whitney': '/images/trainers/supports/whitney.png',
  'Morty': '/images/trainers/supports/morty.png',
  'Chuck': '/images/trainers/supports/chuck.png',
  'Jasmine': '/images/trainers/supports/jasmine.png',
  'Pryce': '/images/trainers/supports/pryce.png',
  'Clair': '/images/trainers/supports/clair.png',
  // Hoenn Gym Leaders
  'Wallace': '/images/trainers/gym-leaders/wallace.png',
  'Flannery': '/images/trainers/gym-leaders/flannery.png',
  'Winona': '/images/trainers/gym-leaders/winona.png',
  'Wattson': '/images/trainers/gym-leaders/wattson.png',
  'Juan': '/images/trainers/gym-leaders/juan.png',
  // Elite Four / Other
  'Bruno': '/images/trainers/gym-leaders/bruno.png',
  'Agatha': '/images/trainers/gym-leaders/agatha.png',
  'Will': '/images/trainers/gym-leaders/will.png',
  'Lorelei': '/images/trainers/gym-leaders/lorelei.png',
  'Lance': '/images/trainers/gym-leaders/lance.png',
};

// Support Card Trainer Images (maps trainer names from support cards)
export const SUPPORT_TRAINER_IMAGES = {
  // Legendary tier (original)
  'Cynthia': '/images/trainers/supports/cynthia.png',
  'Red': '/images/trainers/supports/red.png',
  'Steven': '/images/trainers/supports/steven.png',
  'N': '/images/trainers/supports/n.png',
  'Professor Oak': '/images/trainers/supports/professor_oak.png',
  'Diantha': '/images/trainers/supports/diantha.png',
  // Legendary tier (new)
  'Leon': '/images/trainers/supports/leon.png',
  'Selene': '/images/trainers/supports/selene.png',
  'Mars': '/images/trainers/supports/mars.png',
  'Lusamine': '/images/trainers/supports/lusamine.png',
  'Gloria': '/images/trainers/supports/gloria.png',
  'Nemona': '/images/trainers/supports/nemona.png',
  'Giacomo': '/images/trainers/supports/giacomo.png',
  'Victor': '/images/trainers/supports/victor.png',
  'Arven': '/images/trainers/supports/arven.png',
  'Penny': '/images/trainers/supports/penny.png',
  'Sonia': '/images/trainers/supports/sonia.png',
  'Hop': '/images/trainers/supports/hop.png',
  'Geeta': '/images/trainers/supports/geeta.png',
  'Kieran': '/images/trainers/supports/kieran.png',
  'Carmine': '/images/trainers/supports/carmine.png',
  'Drayton': '/images/trainers/supports/drayton.png',
  'Lacey': '/images/trainers/supports/lacey.png',
  // Rare tier (original)
  'Lance': '/images/trainers/supports/lance.png',
  'Sabrina': '/images/trainers/supports/sabrina.png',
  'Morty': '/images/trainers/supports/morty.png',
  'Wallace': '/images/trainers/supports/wallace.png',
  'Iris': '/images/trainers/supports/iris.png',
  'Blue': '/images/trainers/supports/blue.png',
  'Giovanni': '/images/trainers/supports/giovanni.png',
  'Hilda': '/images/trainers/supports/hilda.png',
  'Archie': '/images/trainers/supports/archie.png',
  'Maxie': '/images/trainers/supports/maxie.png',
  'Mustard': '/images/trainers/supports/mustard.png',
  'Shelly': '/images/trainers/supports/shelly.png',
  // Rare tier (new)
  'Malva': '/images/trainers/supports/malva.png',
  'Oleana': '/images/trainers/supports/oleana.png',
  'Raihan': '/images/trainers/supports/raihan.png',
  'Marnie': '/images/trainers/supports/marnie.png',
  'Nessa': '/images/trainers/supports/nessa.png',
  'Bea': '/images/trainers/supports/bea.png',
  'Opal': '/images/trainers/supports/opal.png',
  'Piers': '/images/trainers/supports/piers.png',
  'Rika': '/images/trainers/supports/rika.png',
  'Poppy': '/images/trainers/supports/poppy.png',
  // Uncommon tier (original)
  'Misty': '/images/trainers/supports/misty.png',
  'Brock': '/images/trainers/supports/brock.png',
  'Erika': '/images/trainers/supports/erika.png',
  'Blaine': '/images/trainers/supports/blaine.png',
  'Koga': '/images/trainers/supports/koga.png',
  'Jasmine': '/images/trainers/supports/jasmine.png',
  'Winona': '/images/trainers/supports/winona.png',
  'Karen': '/images/trainers/supports/karen.png',
  'Agatha': '/images/trainers/supports/agatha.png',
  // Uncommon tier (new)
  'Milo': '/images/trainers/supports/milo.png',
  'Kabu': '/images/trainers/supports/kabu.png',
  'Melony': '/images/trainers/supports/melony.png',
  'Gordie': '/images/trainers/supports/gordie.png',
  'Klara': '/images/trainers/supports/klara.png',
  'Avery': '/images/trainers/supports/avery.png',
  'Iono': '/images/trainers/supports/iono.png',
  'Grusha': '/images/trainers/supports/grusha.png',
  'Zinnia': '/images/trainers/supports/zinnia.png',
  // Common tier
  'Whitney': '/images/trainers/supports/whitney.png',
  'Mallow': '/images/trainers/supports/mallow.png',
  'Allister': '/images/trainers/supports/allister.png',
  'Pryce': '/images/trainers/supports/pryce.png',
  'Wattson': '/images/trainers/supports/wattson.png',
  'Flannery': '/images/trainers/supports/flannery.png',
  // Move Type Distribution supports (new)
  'Dawn': '/images/trainers/supports/dawn.png',
  'Elesa': '/images/trainers/supports/elesa.png',
  'Volkner': '/images/trainers/supports/volkner.png',
  'Gardenia': '/images/trainers/supports/gardenia.png',
  'Lisia': '/images/trainers/supports/lisia.png',
  'Clemont': '/images/trainers/supports/clemont.png',
  'Cress': '/images/trainers/supports/cress.png',
  'Lyra': '/images/trainers/supports/lyra.png',
  'Marlon': '/images/trainers/supports/marlon.png',
  'Cilan': '/images/trainers/supports/cilan.png',
  // Elite 4 Members
  'Lorelei': '/images/trainers/gym-leaders/lorelei.png',
  'Bruno': '/images/trainers/supports/bruno-gen3.png',
  'Will': '/images/trainers/supports/will.png',
  'Sidney': '/images/trainers/supports/sidney.png',
  'Phoebe': '/images/trainers/supports/phoebe-gen6.png',
  'Glacia': '/images/trainers/supports/glacia.png',
  'Drake': '/images/trainers/supports/drake-gen3.png',
  'Aaron': '/images/trainers/supports/aaron.png',
  'Bertha': '/images/trainers/supports/bertha.png',
  'Flint': '/images/trainers/supports/flint.png',
  'Lucian': '/images/trainers/supports/lucian.png',
  'Shauntal': '/images/trainers/supports/shauntal.png',
  'Grimsley': '/images/trainers/supports/grimsley.png',
  'Caitlin': '/images/trainers/supports/caitlin.png',
  'Marshal': '/images/trainers/supports/marshal.png',
};

// Helper function to get gym leader image with fallback
// Now also checks support trainer images since gym leaders can come from the support pool
export const getGymLeaderImage = (name) => {
  return GYM_LEADER_IMAGES[name] || SUPPORT_TRAINER_IMAGES[name] || '/images/trainers/gym-leaders/default.png';
};

// Helper function to get support trainer image with fallback to gym leader images
export const getSupportTrainerImage = (trainerName) => {
  // First check support images, then fallback to gym leader images
  return SUPPORT_TRAINER_IMAGES[trainerName] || GYM_LEADER_IMAGES[trainerName] || '/images/trainers/supports/default.png';
};

// Helper function to get face positioning config for a trainer
export const getTrainerFaceConfig = (trainerName) => {
  return TRAINER_FACE_CONFIG[trainerName] || TRAINER_FACE_CONFIG.default;
};

// Helper to extract trainer name from card name (doesn't need game data)
const extractTrainerName = (cardName) => {
  if (!cardName) return null;

  // If it contains &, it's a display name format
  if (cardName.includes('&')) {
    return cardName.split('&')[0]?.trim();
  }

  // Handle special cases
  const specialCases = {
    'ProfessorOakMew': 'Professor Oak',
    'ElitesFourKaren': 'Karen',
    'LtSurgeRaichu': 'Lt. Surge',
    'PopPyTinkaton': 'Poppy',
    'PennyVaporeon': 'Penny',
    'AveryRapidashGalar': 'Avery'
  };

  if (specialCases[cardName]) {
    return specialCases[cardName];
  }

  // Pokemon names to strip from the end
  const pokemonNames = [
    'Garchomp', 'Charizard', 'Metagross', 'Dragonite', 'Starmie', 'Onix',
    'Tangela', 'Alakazam', 'Magmar', 'Weezing', 'Miltank', 'Gengar',
    'Poliwrath', 'Steelix', 'Delibird', 'Milotic', 'Skarmory', 'Magneton',
    'Camerupt', 'Lucario', 'Reshiram', 'Haxorus', 'Umbreon', 'Pidgeot',
    'Persian', 'Mew', 'Diancie', 'Groudon', 'Kyogre',
    'Lunala', 'Zacian', 'Koraidon', 'Urshifu', 'Eternatus', 'Mabosstiff',
    'Sylveon', 'Yamper', 'Zamazenta', 'Kingambit', 'Terapagos', 'Ogerpon',
    'Archaludon', 'Excadrill',
    'Duraludon', 'Grimmsnarl', 'Drednaw', 'Machamp', 'Alcremie', 'Toxtricity',
    'Whiscash', 'Tinkaton',
    'Eldegoss', 'Centiskorch', 'Lapras', 'Coalossal', 'Slowbro', 'Rapidash',
    'Luxray', 'Altaria'
  ];

  for (const pokemon of pokemonNames) {
    if (cardName.endsWith(pokemon)) {
      return cardName.slice(0, -pokemon.length);
    }
  }

  return cardName;
};

/**
 * Helper function to extract trainer name from support card name or key
 * Handles both formats:
 * - Display name: "Cynthia & Garchomp"
 * - Key format: "CynthiaGarchomp" (legacy) or "Cynthia" (new)
 *
 * @param cardName - The card name or key
 * @param SUPPORT_CARDS - Support cards data from GameDataContext
 * @param normalizeSupportName - Name normalization function from GameDataContext
 */
export const getSupportImageFromCardName = (cardName, SUPPORT_CARDS, normalizeSupportName) => {
  if (!cardName) return null;

  // If we have game data, try to look up the support card
  if (SUPPORT_CARDS && normalizeSupportName) {
    const normalizedName = normalizeSupportName(cardName);
    const supportCard = SUPPORT_CARDS[normalizedName];
    if (supportCard) {
      // Use the trainer name from the support card
      return getSupportTrainerImage(supportCard.trainer || supportCard.name);
    }
  }

  // Fallback: extract trainer name from card name format
  const trainerName = extractTrainerName(cardName);
  return getSupportTrainerImage(trainerName);
};

/**
 * Get support image with face positioning config
 * Returns { image, config, trainerName } where config has scale, offsetX, offsetY
 *
 * @param cardName - The card name or key
 * @param SUPPORT_CARDS - Support cards data from GameDataContext (optional)
 * @param normalizeSupportName - Name normalization function from GameDataContext (optional)
 */
export const getSupportImageWithConfig = (cardName, SUPPORT_CARDS, normalizeSupportName) => {
  if (!cardName) return { image: null, config: TRAINER_FACE_CONFIG.default, trainerName: null };

  let trainerName;

  // If we have game data, try to look up the support card
  if (SUPPORT_CARDS && normalizeSupportName) {
    const normalizedName = normalizeSupportName(cardName);
    const supportCard = SUPPORT_CARDS[normalizedName];
    if (supportCard) {
      trainerName = supportCard.trainer || supportCard.name;
    }
  }

  // Fallback to extracting from legacy format
  if (!trainerName) {
    trainerName = extractTrainerName(cardName);
  }

  const image = getSupportTrainerImage(trainerName);
  const config = getTrainerFaceConfig(trainerName);
  return { image, config, trainerName };
};
